"use client";
import React from "react";
import { useEffectOnce } from "usehooks-ts";

import PreLoader from "./components/other/PreLoader";
import useBlobity from "./components/blobity/useBlobity";

import Blur from "./components/overlay/Blur";
import Color from "./components/overlay/Color";

import NavBar from "./sections/NavBar";
import Hero from "./sections/Hero";
import About from "./sections/About";
import Formations from "./sections/Formations";
import Work from "./sections/Work";
import Contact from "./sections/Contact";
import Footer from "./sections/Footer";
import Tools from "./sections/Tools.tsx";
import Experience from "./sections/Experience";
import Loisirs from "./sections/Loisirs";

export default function Home() {
  useEffectOnce(() => {
    const hash = window.location.hash.slice(1);
    if (hash) {
      // Attendre le rendu + PreLoader avant de scroller vers la section
      const scrollToHash = () => {
        const element = document.getElementById(hash);
        if (element) {
          const offsetTop =
            element.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({ top: offsetTop, behavior: "smooth" });
        }
      };
      setTimeout(scrollToHash, 3500);
      return;
    }

    window.scrollTo({
      top: 0,
      left: 0,
    });
  });

  useBlobity({
    licenseKey: "opensource",
    focusableElementsOffsetX: 4,
    focusableElementsOffsetY: 4,
    color: "#ffffff",
    dotColor: "#ffffff",
    invert: true,
    focusableElements:
      "[data-blobity], a:not([data-no-blobity]), h4:not([data-no-blobity]), li:not([data-no-blobity]), button:not([data-no-blobity]), [data-blobity-tooltip]",
    font: "'Inter', sans-serif",
    fontSize: 16,
    fontWeight: 900,
    opacity: 1.0,
    fontColor: "#ffffff",
    zIndex: 35,
    size: 50,
    radius: 5,
    magnetic: false,
  });

  return (
    <>
      <PreLoader />
      <Blur />
      <Color />
      <NavBar />
      <main className="flex flex-col items-center justify-center bg-black">
        <Hero title="Hello, je m'appelle Fabian Menoni" />
        <About />
        <Formations />
        <Experience />
        <Work />
        <Tools />
        <Loisirs />
        <Contact />
        <Footer />
      </main>
    </>
  );
}
